// Components/RoleRoute.js
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/userContext.js';
import ROLES from '../common/roles.js';

export default function RoleRoute({
    allowed,      // e.g. [ROLES.MANAGER, ROLES.SENIOR_MANAGER]
    redirect = '/login'
}) {
    // ← use array destructuring to grab your state object
    const [{ user, loading }] = useAuth();

    // (optional) you can render a loader/spinner here
    if (loading) return null;

    // not signed in → login
    if (!user) return <Navigate to={redirect} replace />;

    // if role matches one in `allowed`, or is ADMIN → render nested routes
    if (allowed.includes(user.role) || user.role === ROLES.ADMIN) {
        return <Outlet />;
    }

    // otherwise → unauthorized page
    return <Navigate to="/unauthorized" replace />;
}
